import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { BookmarkSimple, X } from '@phosphor-icons/react';
import { toast } from '../../hooks/use-toast';

export const SaveEstimateModal = ({ isOpen, onClose, onSave, formData }) => {
  const [name, setName] = useState('');
  const [saving, setSaving] = useState(false);
  
  if (!isOpen) return null;
  
  const handleSave = async () => {
    if (!name.trim()) {
      toast({ title: 'Please enter a name', variant: 'destructive' });
      return;
    }
    setSaving(true);
    await onSave(name.trim());
    setSaving(false);
    setName('');
    onClose();
  };
  
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full max-w-md bg-white dark:bg-[#0F172A] border-2 border-black dark:border-white shadow-[8px_8px_0px_#000] dark:shadow-[8px_8px_0px_#2B4C6F]">
        <div className="p-4 border-b-2 border-black dark:border-white bg-[#2B4C6F] text-white flex items-center justify-between">
          <div className="flex items-center gap-2">
            <BookmarkSimple size={20} weight="fill" />
            <h3 className="font-black uppercase tracking-wide">Save Estimate</h3>
          </div>
          <button onClick={onClose} className="hover:bg-white/20 p-1 rounded"><X size={20} /></button>
        </div>
        <div className="p-5 space-y-4">
          <div>
            <Label className="font-bold uppercase tracking-wider text-xs mb-2 block">Name this estimate</Label>
            <Input
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder={`${formData?.job_type || 'Job'} - ${formData?.location || 'Location'}`}
              className="h-12 border-2 border-black dark:border-white rounded-none"
              data-testid="save-estimate-name"
            />
          </div>
          <div className="flex gap-3">
            <Button onClick={onClose} variant="outline" className="flex-1 h-12 border-2 border-black rounded-none font-bold">
              Cancel
            </Button>
            <Button 
              onClick={handleSave} 
              disabled={saving}
              className="flex-1 h-12 bg-[#2B4C6F] hover:bg-[#203A55] text-white border-2 border-black rounded-none font-bold shadow-[4px_4px_0px_#000]"
              data-testid="confirm-save-btn"
            >
              {saving ? 'Saving...' : 'Save'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
